import {CardContent, List, ListItem} from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import {blue, grey} from '@mui/material/colors'
import {useAppNavigate} from 'app/hooks/navigation/useAppNavigate'
import PricingTable from './components/pricingTable'
import AppBar from './header/AppBar'

function Pricing() {
  const navigate = useAppNavigate()
  const handleRegisterRoute = (type: string) => {
    let to = ''
    //isout plans
    if (type === 'team' || type === 'single' || type === 'custom') {
      to = 'iscout'
    }
    //free plan
    if (type === 'free') {
      to = 'free'
    }
    //free plan
    if (type === 'hci') {
      to = 'hci'
    }

    navigate(`/register?type=${to}`)
  }
  return (
    <Box sx={{backgroundColor: '#f5f8fa'}}>
      <Box sx={{minHeight: 'calc(100vh - 70px'}}>
        <AppBar />
      </Box>
      <Box maxWidth={'1320px'} margin={'auto'} display={'flex'} flexDirection={'column'}>
        <Box display={'flex'} flexDirection={'column'} flexGrow={1} flex={'1 1 auto'}>
          <Grid item xs={12} mt={5}>
            <Box display={'flex'} alignItems={'center'} flexDirection={'column'}>
              <Typography variant={'h3'}>Subscription Plans, Features, and Pricing</Typography>
              <Typography variant={'subtitle1'} fontSize={'1.5em'}>
                Get started with the plan that fits your needs best.
              </Typography>
            </Box>
          </Grid>
          <Box display={'flex'} flex={'1 1 auto'} flexDirection={'column'}>
            <Box display={'flex'} flex={'1 1 auto'} flexDirection={'row'}>
              <Box flex={'1 1 auto'} display={'flex'}>
                <Box display={'flex'} flex={'1 1 80%'}>
                  <PricingTable handleRegisterRoute={handleRegisterRoute} />
                </Box>
              </Box>
              <Box flex={'1 1 20%'} display={'flex'} flexDirection={'column'}>
                <Card
                  elevation={1}
                  sx={{display: 'flex', flexDirection: 'column', flex: '1', p: 1, mt: 1, mr: 1}}
                >
                  <CardHeader
                    title={
                      <Box>
                        <Typography variant={'h4'} color={blue[600]}>
                          Free Plan
                        </Typography>
                        <List sx={{ml: 1}}>
                          <ListItem disablePadding>
                            <Typography>
                              Sign up to manage your business or personal profile
                            </Typography>
                          </ListItem>
                        </List>
                        <Divider color={grey[500]} />
                        <Typography variant={'subtitle1'} mt={2} ml={1}>
                          Want to control your business' profile, but don't need the tech scouting?{' '}
                          <br />
                          We offer a free account for managing your profile and details related to
                          your company.
                        </Typography>
                      </Box>
                    }
                    subheader={
                      <>
                        <Box mt={2}>
                          <Typography variant={'h4'} color={blue[600]}>
                            Single User Plan
                          </Typography>
                          <List sx={{ml: 1}}>
                            <ListItem disablePadding>
                              <Typography>Monthly Subscription: $199/mo</Typography>
                            </ListItem>
                            <ListItem disablePadding>
                              <Typography>
                                Annual Subscription: $149/mo (i.e. $1788/year)
                              </Typography>
                            </ListItem>
                          </List>
                        </Box>
                        <Box mt={1}>
                          <Typography variant={'h4'} color={blue[600]}>
                            Standard Plan
                          </Typography>
                          <List sx={{ml: 1}}>
                            <ListItem disablePadding>
                              <Typography>5 Seats: Monthly Subscription: $649/mo</Typography>
                            </ListItem>
                            <ListItem disablePadding>
                              <Typography>
                                5 Seats: Annual Subscription: $499/mo (i.e. $5988/year)
                              </Typography>
                            </ListItem>
                          </List>
                          <List sx={{ml: 1}}>
                            <ListItem disablePadding>
                              <Typography>10 Seats: Monthly Subscription: $1,169/mo</Typography>
                            </ListItem>
                            <ListItem disablePadding>
                              <Typography>
                                10 Seats: Annual Subscription: $899/mo (i.e. $10788/year)
                              </Typography>
                            </ListItem>
                          </List>
                          <List sx={{ml: 1}}>
                            <ListItem disablePadding>
                              <Typography>20 Seats: Monthly Subscription: $2209/mo</Typography>
                            </ListItem>
                            <ListItem disablePadding>
                              <Typography>
                                20 Seats: Annual Subscription: $1699/mo (i.e. $20,388/year)
                              </Typography>
                            </ListItem>
                          </List>
                        </Box>
                        <Box mt={1}>
                          <Typography variant={'h4'} color={blue[600]}>
                            Premium Plan
                          </Typography>
                          <List sx={{ml: 1}}>
                            <ListItem disablePadding>
                              <Typography>
                                (5 Seats) Annual Subscription: $699/mo (i.e. $7,788/yr)
                              </Typography>
                            </ListItem>
                          </List>
                          <List sx={{ml: 1}}>
                            <ListItem disablePadding>
                              <Typography>
                                (10 Seats) Annual Subscription: $1,249/mo (i.e. $14,028/yr)
                              </Typography>
                            </ListItem>
                          </List>
                          <List sx={{ml: 1}}>
                            <ListItem disablePadding>
                              <Typography>
                                (20 Seats) Annual Subscription: $2,209/mo (i.e. $26,508/yr)
                              </Typography>
                            </ListItem>
                          </List>
                        </Box>
                      </>
                    }
                  >
                    {' '}
                  </CardHeader>

                  <CardContent
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      flexDirection: 'column',
                      flex: '1 1 auto',
                      gap: 2,
                    }}
                  >
                    <Divider color={grey[500]} />
                    <Button
                      color={'info'}
                      onClick={() => navigate('/signup')}
                      variant={'contained'}
                      fullWidth
                      sx={{fontWeight: 700, fontSize: '1.25rem'}}
                    >
                      Sign Up
                    </Button>
                  </CardContent>
                </Card>
              </Box>
            </Box>
          </Box>
          <Box height={'10em'}>
            <Card
              elevation={1}
              sx={{display: 'flex', flexDirection: 'column', flex: '1', p: 1, mt: 1}}
            >
              <CardHeader
                title={<Typography variant={'h5'}>HCI Registration - (Free)</Typography>}
                subheader={
                  <Box>
                    <br />
                    <Divider color={grey[500]} />

                    <Typography variant={'subtitle1'} fontSize={'1.25em'} mt={2}>
                      We are seeking innovative small businesses, faculty, government personnel,
                      systems integrators, consultants and other support organizations to advance
                      the cause of developing hypersonic innovation. To get more information or join
                      the effort, please sign up.
                    </Typography>
                  </Box>
                }
              ></CardHeader>

              <CardContent
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  flexDirection: 'column',
                  flex: '1 1 auto',
                  gap: 1,
                }}
              >
                <Divider color={grey[500]} />
                <Box
                  display={'flex'}
                  flexDirection={'column'}
                  justifyContent={'space-around'}
                  alignContent={'center'}
                  textAlign={'center'}
                  alignItems={'center'}
                  gap={2}
                >
                  <Divider color={grey[500]} />
                  <Button
                    color={'info'}
                    onClick={() => handleRegisterRoute('hci')}
                    variant={'contained'}
                    sx={{fontWeight: 700, fontSize: '1.25rem'}}
                  >
                    HCI Registration Form
                  </Button>
                </Box>
              </CardContent>
            </Card>
            <Box height={'15em'}>
              <></>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export {Pricing}
